import * as o from "react";
import e from "../lib/IconBase.es.js";
import i from "../defs/SquareSplitHorizontal.es.js";
const r = o.forwardRef((t, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...t, weights: i }));
r.displayName = "SquareSplitHorizontalIcon";
const m = r;
export {
  m as SquareSplitHorizontal,
  r as SquareSplitHorizontalIcon
};
